import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname, key } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    document
      .querySelector('[data-dashboard-scroll-container="true"]')
      ?.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, key]);

  return null;
}

export default ScrollToTop;
